import React from 'react'
import styles from '../../info.module.css';
import Logo4 from '../../Assets/Logo4.jpg'

const Privacy = () => {
  return (
    <div>
      <h1 className={styles.header}><a href='/'><img className={styles.logo} src={Logo4} alt="" /></a> Privacy Policy</h1>
      <div className={styles.textContent}>

<p>Welcome to Baker's Nest! We value your privacy, and this Privacy Policy is designed to help you understand how we collect, use, and safeguard your personal information when you visit our website or make a purchase. By using our website, you agree to the terms outlined in this policy.</p>

<h1>1. Information We Collect</h1>

<p>We may collect personal information, such as your name, email address, shipping address, and payment details when you place an order on our website. Additionally, we may collect non-personal information, such as browser type, IP address, and other anonymous data to enhance your experience on our site.</p>

<h1>2. How We Use Your Information</h1>

<p>We use the information collected for order processing, shipping, and customer support. Your email address may be used to send you updates about your order, promotional materials, and newsletters. If you do not wish to receive marketing emails, you can opt out at any time.</p>

<h1>3. Data Security</h1>

<p>We take the security of your information seriously. We implement industry-standard security measures to protect your personal data from unauthorized access, disclosure, alteration, and destruction.</p>

<h1>4. Cookies and Tracking Technologies</h1>

<p>We use cookies and similar tracking technologies to enhance your browsing experience. These technologies may collect information about your online activities over time and across different websites. You can adjust your browser settings to refuse cookies, but this may affect your ability to access certain features on our website.</p>

<h1>5. Third-Party Links</h1>

<p>Our website may contain links to third-party websites. Please note that we are not responsible for the privacy practices of these external sites. We encourage you to read the privacy policies of these websites when you leave our site.</p>

<h1>6. Your Rights</h1>

<p>You have the right to access, correct, or delete your personal information. If you would like to do so or have any concerns about your privacy, please contact us using the information provided at the end of this Privacy Policy.</p>

<h1>7. Changes to the Privacy Policy</h1>

<p>We reserve the right to update or modify this Privacy Policy at any time. Changes will be effective immediately upon posting on our website. We encourage you to review this Privacy Policy periodically to stay informed about how we are protecting your information.</p>

<h1>8. Contact Information</h1>

<p>If you have any questions, concerns, or requests regarding this Privacy Policy, please contact us at:</p>

<p>8595714343 / bakersnest2022@gmail.com</p>

<p>Thank you for choosing Baker's Nest. We are committed to protecting your privacy and providing you with the best possible experience on our website.</p>

</div>
    </div>
  )
}

export default Privacy